import React, { useEffect } from "react";
import { useWizard } from "store/wizard";
import { Loading } from "components/form";
import ReactHtmlParser from "react-html-parser";
import { toJalali } from "lib/helpers";
import { useNavigate } from "react-router-dom";

const PhysicalSummery = (props) => {
  const navigate = useNavigate();
  const {
    product: {
      type,
      countries,
      detail,
      product_categories,
      country_filter_type,
      product_detail,
      physical_detail,
      prices,
      product_owners,
      product_active_times,
    },
    seasons,
    load,
    dispatch,
    previous,
  } = useWizard();
  const wizard = useWizard();

  const TYPES = {
    Movie: "فیلم",
    Serie: "سریال",
    Music: "موزیک",
    SerieEpisode: "قسمتی از سریال",
    Screening: "اکران",
    Physical: "فیزیکی",
    Download: "دانلودی",
    HASHURE_STRIMING: "هاشور",
    DORDIS: "دوردیس",
    VOD: "وی او دی",
    All: "همه",
    Only: "فقط",
    Except: "به جزء",
    fa: "فارسی",
    en: "انگلیسی",
  };
  if (load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="font-medium text-base flex justify-between">
        <h2>پیش نمایش</h2>
        <div>
          <span>وضعیت محصول : </span>
          <button
            className={`btn btn-sm ${
              wizard.product && wizard.product.status == "Publish"
                ? "btn-success"
                : "btn-danger"
            }`}
            onClick={() => wizard.dispatch(wizard.changeStatus())}
          >
            {wizard.product && wizard.product.status == "Publish"
              ? "منتشر شده"
              : "پیش نویس"}
          </button>
        </div>
      </div>
      <hr className="my-2" />
      <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
        <div className="col-span-12 grid grid-cols-3">
          <div>
            <span>عنوان : </span>
            <span>{detail && detail.title}</span>
          </div>
          <div>
            <span>نوع محصول : </span>
            <span>{TYPES[type]}</span>
          </div>
          <div>
            <span>موجودی انبار : </span>
            <span>{physical_detail.inventory}</span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-2">
          <div>
            <span>دسته بندی ها : </span>
            <span>
              {product_categories.map((item) => item.name).join(" ، ")}
            </span>
          </div>

          <div>
            <span>وزن : </span>
            <span>{physical_detail.weight}</span>
          </div>
          <div>
            <span>طول : </span>
            <span>{physical_detail.length}</span>
          </div>

          <div>
            <span>عرض : </span>
            <span>{physical_detail.width}</span>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-5"></div>
        <div className="col-span-12 grid grid-cols-5">
          <div>
            <span> فیلتر کشور : </span>
            <span>
              {country_filter_type == "All"
                ? TYPES[country_filter_type]
                : country_filter_type == "Only"
                ? TYPES[country_filter_type] +
                  " : " +
                  (countries &&
                    countries.length > 0 &&
                    countries.map((item) => item.fa_name).join(" ، "))
                : TYPES[country_filter_type] +
                  " : " +
                  (countries &&
                    countries.length > 0 &&
                    countries.map((item) => item.fa_name).join(" ، "))}
            </span>
          </div>
        </div>

        <div className="col-span-12 grid grid-cols-2 gap-4">
          <div>
            <span>درباره محصول :</span>
            <p className="text-justify rounded border-dashed border-2 p-1">
              {detail && ReactHtmlParser(detail.full_desc)}
            </p>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-3 gap-2">
          <div className="p-2">
            <p>تصویر </p>
            <div className="mt-2 flex justify-center">
              <img
                className="h-48"
                src={
                  physical_detail &&
                  physical_detail.media &&
                  physical_detail.media.url
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="col-span-12 grid grid-cols-2 gap-4"></div>
        {wizard.type != "Serie" && (
          <div className="col-span-12 grid grid-cols-5 gap-4">
            <div className="text-center col-span-2 border-2 border-dashed rounded p-2">
              <p className="grid grid-cols-3 gap-4">
                <span className="col-span-2">قیمت ها</span>
                <span>وضعیت</span>
              </p>
              <hr className="my-1" />
              {prices.map((item) => (
                <div className="grid grid-cols-3 gap-4">
                  <p className="col-span-2">
                    <span>{item.amount}</span>
                    <span>{item.currency == "IRR" ? " تومان" : " دلار"}</span>
                  </p>
                  <p>{item.status ? "فعال" : "غیرفعال÷"}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
          <button
            className="btn btn-secondary w-24"
            type="button"
            onClick={() => {
              dispatch(previous());
            }}
          >
            قبلی
          </button>
          <button
            className="btn btn-primary w-24 mr-2"
            onClick={() => navigate(-1)}
          >
            خروج
          </button>
        </div>
      </div>
    </>
  );
};

export default PhysicalSummery;
